import React, { useEffect, useState, useCallback, useContext } from "react";
import classNames from "classnames/bind";
import { toast } from "react-toastify";

// components
import { NewNavbar } from "src/components";
import { CustomMap, Loader, MobileContent } from "./components";

// data
import { events } from "./utils/data";

// network
import { fetchNearByEvents } from "./utils/network";
import { getDirection } from "./utils";

// context
import UserContext from "src/context/User";

import styles from "./MapContent.module.scss";
const cx = classNames.bind(styles);

const MapContent = () => {
  // context
  const { user, userLocation } = useContext(UserContext);

  // states
  const [isMobView, setIsMobView] = useState(false);
  const [isOpenMobSlider, setIsOpenMobSlider] = useState(false);

  const [listOfEvents, setListOfEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentVisible, setCurrentVisible] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [direction, setDirection] = useState(null);
  const [refCount, setRefCount] = useState(0);
  const [userCoords, setUserCoords] = useState(null);

  const handleResize = useCallback(() => {
    if (window.innerWidth < 768) setIsMobView(true);
    else setIsMobView(false);

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh-mob", `${vh}px`);
  }, []);

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);

      const bottomEL = document.getElementById("bottom-bar");
      if (bottomEL) bottomEL.style.display = "block";
    };
  }, [handleResize]);

  useEffect(() => {
    if (user || userLocation) {
      let coords = {};

      if (user) {
        coords.lat = user.location.lat;
        coords.lng = user.location.lng;
      } else {
        coords.lat = userLocation.lat;
        coords.lng = userLocation.lng;
      }

      setUserCoords(coords);
      // setRefCount((count) => count + 1);
      fetchEvents(coords, 50);
    }
  }, [user, userLocation]);

  const fetchEvents = (_coords, _raduis) => {
    let data = {
      lat: _coords.lat,
      lng: _coords.lng,
      radius: _raduis,
    };

    setIsLoading(true);
    fetchNearByEvents(data)
      .then((res) => {
        if (res.data.Status) {
          setListOfEvents(res.data.Results.Events);
          setRefCount((count) => count + 1);
          setIsLoading(false);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
        console.log(err);
      });
  };

  const handleDirection = useCallback(
    (_data) => {
      console.log({ userCoords, _data });
      setCurrentVisible(_data);
      // let map re-render
      setRefCount((count) => count + 1);

      /** calculate direction between user and marker coordinates */
      // getDirection(userCoords, _eCoords)
      //   .then((result) => {
      //     if (result.status === "OK") {
      //       setDirection(result);
      //       setRefCount((count) => count + 1);
      //     } else {
      //       console.error(`error fetching directions ${result}`);
      //     }
      //   })
      //   .catch((err) => console.log(err));
    },
    [userCoords]
  );

  const handleMarkerClick = useCallback(
    (_data) => {
      if (!isOpenMobSlider) {
        setIsOpenMobSlider(true);
        document.getElementById("bottom-bar").style.display = "none";
      }

      setSelectedEvent(_data);
      handleDirection({
        id: _data.EventId,
        coords: {
          lat: Number(_data.Latitude),
          lng: Number(_data.Longitude),
        },
      });
    },
    [isOpenMobSlider, handleDirection]
  );

  const handleClose = () => {
    setIsOpenMobSlider(false);

    if (direction) {
      setDirection(null);
      setRefCount((count) => count + 1);
    }

    if (currentVisible) {
      setCurrentVisible(null);
      setRefCount((count) => count + 1);
    }

    document.getElementById("bottom-bar").style.display = "block";
  };

  return (
    <div>
      <NewNavbar isMobHide />
      <div className={cx("map-content-root")}>
        {!isLoading ? (
          <>
            <CustomMap
              events={listOfEvents}
              handleClick={handleMarkerClick}
              userCoords={userCoords}
              currentVisible={currentVisible}
              direction={direction}
              refCount={refCount}
            />
            {isMobView && (
              <MobileContent
                events={listOfEvents}
                isOpen={isOpenMobSlider}
                selected={selectedEvent}
                handleClose={handleClose}
                handleDirection={handleDirection}
              />
            )}
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default MapContent;
